import clsx from 'clsx';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import { OfferOption } from '../../utils/backend-api/subscribe';
import { SelectedOffer } from '../../utils/backend-api/subscribe';
import CustomRadio from './CustomRadio';
import Tag from './Tag';

interface OfferProps extends OfferOption {
  isSingleOffer?: boolean;
  selectedOffer: SelectedOffer;
  setSelectedOffer?: (offer: SelectedOffer) => void;
}

const Offer = ({
  benefits,
  currentPrice,
  originalPrice,
  frequency,
  isMostPopular,
  isSingleOffer,
  code,
  selectedOffer,
  setSelectedOffer,
  title,
}: OfferProps) => {
  const isSelected = selectedOffer.code === code;

  return (
    <div
      id={code}
      onClick={() =>
        setSelectedOffer({
          frequency,
          code,
          currentPrice,
          originalPrice,
        })
      }
      className={clsx(
        'tw-relative tw-block tw-border tw-border-slate-200 tw-border-solid tw-rounded-10  tw-mb-20 tw-px-16 tw-py-20 tw-cursor-pointer',
        {
          'selected tw-bg-primary-black tw-border-0 tw-shadow-[0_0_8px_1px_rgba(121,130,149,1)]':
            isSelected,
          'tw-pointer-events-none': isSingleOffer,
        }
      )}
    >
      <div className="tw-flex tw-items-center">
        <CustomRadio isSelected={isSelected} />
        <h2
          className={clsx(
            'tw-m-0 tw-text-[26px] tw-font-serif tw-font-bold tw-text-primary-black',
            {
              'tw-text-white': isSelected,
            }
          )}
        >
          {title}
        </h2>
        {isMostPopular && !isSingleOffer && <Tag name="Most Popular" className="popular-plan" />}
        {isSingleOffer && <Tag name="Best Value" className="tw-absolute -tw-top-8 tw-right-12" />}
      </div>
      <div className="tw-flex tw-items-center tw-mt-36">
        <span
          className={clsx('tw-font-sans tw-font-medium tw-text-primary-black', {
            'tw-text-white': isSelected,
          })}
        >
          ${currentPrice.toFixed(2)}
        </span>{' '}
        {originalPrice && (
          <span className="tw-font-sans tw-font-medium tw-text-gray-400 tw-line-through tw-ml-6">
            ${originalPrice.toFixed(2)}
          </span>
        )}
      </div>
      <div
        className={clsx(
          'tw-text-body-sm xs:tw-text-subtitle-serif tw-text-gray-500 tw-font-sans tw-mt-2',
          {
            'tw-text-neutral-400': isSelected,
          }
        )}
      >
        {ReactHtmlParser(benefits)}
      </div>
    </div>
  );
};

export default Offer;
